import {Injectable} from '@angular/core';
//import {Store} from '@ngrx/store';
import {PKEY} from '../../constants/persistence.constants';
//import {AppActions} from '../../store/actions';
import {AllowedLocal, AuthService, Session} from './auth.service';
import {PersistenceService} from "./persistence.service";
import {Operador} from "../models/operador.model";
import {Cliente} from "../models/cliente.model";
import {environment} from "../../../environments/environment";

@Injectable()
export class UserService {
  userId = 0;
  userName = 'Guest'
  userMail = ''
  typeContainer = ''
  userToken = '';
  termsConditions = '';
  urlRedirect = '';
  urlOrigin = '';
  permissionList: string = '';
  type: string = '';
  data: any = {};
  operador?: Operador;
  cliente?: Cliente;
  allowedLocals: AllowedLocal[] = [];
  operadorList: Operador[] = [];

  constructor(
    private persistence: PersistenceService,
    private auth: AuthService,
  ) { }

  get isAuthenticated() {
    return this.userToken && this.userToken.trim() !== "";
  }

  verifiedAuthenticated(){
    if (!this.isAuthenticated) {
      this.goToLogin();
    }
  }

  async verifiedToken(){
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    const data = url.searchParams.get('data');

    if(token && data){

      const jsonString = atob(data);

      const dataObject = JSON.parse(jsonString);

      await this.login(dataObject);
    }
  }

  initialize() {
    this.userId = this.persistence.get(PKEY.USER_ID);
    this.userName = this.persistence.get(PKEY.USER_NAME);
    this.userToken = this.persistence.get(PKEY.USER_TOKEN);
    this.permissionList = this.persistence.get(PKEY.PRIVIGELES);
    this.urlOrigin = this.persistence.get(PKEY.URL_ORIGIN);
    this.operador = this.persistence.get(PKEY.OPERADOR);
    this.cliente = this.persistence.get(PKEY.CLIENTE);
    this.allowedLocals = this.persistence.get(PKEY.ALLOWED_LOCALES);
    this.operadorList = this.persistence.get(PKEY.OPERADOR_LIST);
    this.termsConditions = this.persistence.get(PKEY.TERMS_CONDITIONS);
    this.userMail = this.persistence.get(PKEY.USER_MAIL);
    this.typeContainer = this.persistence.get(PKEY.TYPE_CONTAINER);
    this.type = this.persistence.get(PKEY.TYPE);
    //this.data = this.persistence.get(PKEY.DATA);
  }

  goToLogin(logout = '') {

    let url = this.urlOrigin;
    if(!url){
      url = environment.URL_LOGIN;
    }
    window.location.href = `${url}${logout}`;

  }

  login(data: Session) {
    this.auth.createSession(data);
    //this.store.dispatch(AppActions.Login());
  }

  setOperador(data: Operador){
    this.persistence.set(PKEY.OPERADOR, data);
  }

  setTermsConditions(data: string){
    this.persistence.set(PKEY.TERMS_CONDITIONS, data);
  }


  logout() {
    this.auth.clearUserSession();
    this.goToLogin('?logout=1');
    //this.store.dispatch(AppActions.Logout());
  }
}
